const toBoolFlag = (value) => value === true || value === 'true' || value === 1;
const toZoneQty = (value) => {
  const parsed = Number.parseInt(String(value ?? 0), 10);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const normalizeZoneStockSearchItem = (item) => {
  if (!item || typeof item !== 'object') {
    return item;
  }

  const issueQty = toZoneQty(item.issue ?? item.Issue ?? 0);
  const soldQty = toZoneQty(item.sold ?? item.Sold ?? 0);
  const returnQty = toZoneQty(item.return ?? item.Return ?? item.ReturnQty ?? 0);

  const normalized = {
    ...item,
    id:
      item.id ??
      item.po_product_id ??
      item.product_id ??
      item.Item_id ??
      item._id ??
      null,
    po_product_id:
      item.po_product_id ?? item.id ?? item.product_id ?? item.Item_id ?? null,
    product_id:
      item.product_id ?? item.po_product_id ?? item.id ?? item.Item_id ?? null,
    SKU: item.SKU ?? item.sku ?? item.Sku ?? '-',
    stock_id:
      item.stock_id ??
      item.stockId ??
      item.Stock_id ??
      item.Stock_ID ??
      item.StockID ??
      '',
    main_image: item.main_image ?? item.mainImage ?? item.image ?? '',
    item_name: item.item_name ?? item.Item_name ?? item.itemName ?? item.item ?? '-',
    collection_name:
      item.collection_name ?? item.Collection_name ?? item.collection ?? '-',
    size: item.size ?? item.Size_name ?? item.size_name ?? item.Size ?? '-',
    issue: issueQty,
    sold: soldQty,
    return: returnQty,
    balance: issueQty - soldQty - returnQty,
  };

  if (toBoolFlag(item.new_add)) {
    normalized.new_add = true;
  }
  if (toBoolFlag(item.new_return)) {
    normalized.new_return = true;
  }
  if (toBoolFlag(item.refillSoldStatus)) {
    normalized.refillSoldStatus = true;
  }

  return normalized;
};

export const normalizeZoneStockSearchItems = (items) =>
  (items || []).map(normalizeZoneStockSearchItem);

export const mergeIssueRowWithStockSearch = (existingRow, apiItem) => {
  const normalized = normalizeZoneStockSearchItem(apiItem);
  if (!existingRow) {
    return normalized;
  }

  const merged = {
    ...existingRow,
    ...normalized,
  };

  if (existingRow.new_add || normalized.new_add) {
    merged.new_add = true;
  }
  if (existingRow.new_return || normalized.new_return) {
    merged.new_return = true;
  }
  if (existingRow.refillSoldStatus || normalized.refillSoldStatus) {
    merged.refillSoldStatus = true;
  }

  merged.issue = toZoneQty(existingRow.issue ?? merged.issue);
  merged.sold = toZoneQty(existingRow.sold ?? merged.sold);
  merged.return = toZoneQty(existingRow.return ?? merged.return);
  merged.balance = merged.issue - merged.sold - merged.return;

  return merged;
};

export const buildChatDirectIssueRow = (product) =>
  normalizeZoneStockSearchItem({
    id: product?.id ?? product?.po_product_id ?? null,
    po_product_id: product?.id ?? product?.po_product_id ?? null,
    product_id: product?.id ?? product?.po_product_id ?? null,
    stock_id: product?.stock_id ?? '',
    SKU: product?.SKU ?? product?.sku ?? '-',
    main_image: product?.main_image ?? product?.mainImage ?? '',
    item_name: product?.item_name ?? product?.itemName ?? '-',
    collection_name: product?.collection_name ?? product?.collection ?? '-',
    size: product?.size_name ?? product?.size ?? '-',
    issue: 1,
    sold: 0,
    return: 0,
    balance: 1,
    new_add: true,
  });

export const buildChatDirectReissueRow = (row) => {
  const {
    _issueBase,
    _issueNow,
    _issueMaxNow,
    _issueDraftActive,
    ...base
  } = row || {};

  const issue = toZoneQty(base.issue);
  const sold = toZoneQty(base.sold);
  const returnQty = toZoneQty(base.return ?? base.Return ?? base.ReturnQty);
  const newIssue = issue + 1;
  const newBalance = newIssue - sold - returnQty;

  const next = {
    ...base,
    issue: newIssue,
    return: returnQty,
    balance: newBalance,
    new_add: true,
  };

  if (!base._changeSnapshot) {
    next._changeSnapshot = {
      issue,
      return: returnQty,
      balance: toZoneQty(base.balance),
    };
  }

  return next;
};
